/** Stable public selectors owned by the deferred Kundali form itself. */

const KUNDALI_NAME_PROBE_MARKER = "kundali-name";

export const KUNDALI_NAME_CWV_PROBE = {
  marker: KUNDALI_NAME_PROBE_MARKER,
  activationSelector: `[data-cwv-interaction-activate="${KUNDALI_NAME_PROBE_MARKER}"][data-shell-hydrated="true"]`,
  targetSelector: `[data-cwv-interaction-target="${KUNDALI_NAME_PROBE_MARKER}"]`,
} as const;
